import React from 'react';
import DepartmentWorkPlanner from '../../components/DepartmentWorkPlanner';

const PurchaseWorkPlanner = () => {
  return <DepartmentWorkPlanner department="purchase" departmentName="Purchase Department" />;
};

export default PurchaseWorkPlanner;
